import none from '../../img/leoLogo.png'

import mangochocolate from '../../img/hotdrink/mangochocolate.jpg'
export const hotDrink=[
    {
      "id": "101",
      "title": "هات چاکلت دارک",
      "desciption": "با سیروپ فندوق",
      "price": "134",
      "image": none
    },
    {
      "id": "102",
      "title": "وایت چاکلت",
      "desciption": "با کره بادام زمینی",
      "price": "128",
      "image": none
    },
   
    {
      "id": "104",
      "title": "شیر عسل دارچین",
      "desciption": "",
      "price": "124",
      "image": none
    },
    {
      "id": "105",
      "title": "pink chocolate",
      "desciption": "",
      "price": "120",
      "image": none
    },
    {
      "id": "106",
      "title": "شیر شکلات",
      "desciption": "",
      "price": "120",
      "image": none
    },
    {
      "id": "107",
      "title": "mango chocolate",
      "desciption": " آب انبه+هات چاكلت+سس چيلي+پودر فلفل قرمز",
      "price": "139",
      "image": mangochocolate
    },
   
  ]